<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">{{ $route.meta.label }}</h1>
        </b-col>
        <b-col>
          <create-config @create-config="handleCreate"></create-config>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table :items="items" :fields="fields" :busy="loading">
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(inputOptions)="row">
              <span class="px-1" v-for="(option, optInde) in row.item.inputOptions" :key="optInde">
                <b-badge :variant="option.color">{{ option.label }}</b-badge>
              </span>
            </template>
            <template #cell(actions)="row">
              <a href="#"><i class="fa fa-lg fa-trash text-danger" @click.prevent="removeRow(row.item.key)"></i></a>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CreateConfig from "./CreateConfig.vue";
export default {
  name: "ConfigurarInocuidad",
  components: {
    CreateConfig
  },
  data() {
    return {
      items: [],
      loading: false,
      fields: [
        { key: "key", label: "Key" },
        { key: "label", label: "Nombre" },
        { key: "inputType", label: "Tipo" },
        { key: "inputOptions", label: "Opciones" },
        { key: "actions", label: "Acciones" }
      ]
    };
  },
  methods: {
    handleCreate(e) {
      this.loading = true;
      this.items.push(e);
      this.updateCertificatesConfig();
    },
    removeRow(key) {
      this.loading = true;
      this.items = this.items.filter((item) => item.key !== key);
      this.updateCertificatesConfig();
    },
    async getCertificatesConfig() {
      this.loading = true;
      const clientId = this.$store.state.user.ID_CLIENTE;
      try {
        const res = await this.$axios.get("/api/qc/certificate_config/" + clientId + "/by_client/");
        this.items = res.data.config;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async updateCertificatesConfig() {
      this.loading = true;
      const clientId = this.$store.state.user.ID_CLIENTE;
      try {
        const res = await this.$axios.put("/api/qc/certificate_config/" + clientId + "/update_config/", {
          config: this.items
        });
        this.items = res.data.config;
        this.$bvToast.toast("Configuración creada", {
          title: "Éxito",
          variant: "success",
          solid: true
        });
      } catch (error) {
        console.log(error);
        this.$bvToast.toast("Error al crear configuración", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getCertificatesConfig();
  }
};
</script>

<style></style>
